import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => ({
  appPageHeader: {
    height: 60,
    display: "flex",
    [theme.breakpoints.down("xs")]: {
      height: 56
    }
  },
  appPageContent: {
    flex: "auto",
    display: "flex",
    flexDirection: "column",
    height: "calc(100dvh - 124px)",
    overflow: "auto",
    padding: "24px",
    [theme.breakpoints.down("xs")]: {
      height: "calc(100dvh - 120px)"
    }
  },
  grid: {
    flexWrap: "nowrap",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column-reverse"
    },
    [theme.breakpoints.up("md")]: {
      height: "100%",
      minHeight: 624
    }
  },
  column: {
    paddingRight: 15,
    "&:last-child": {
      paddingRight: 0,
      paddingLeft: 15,
      [theme.breakpoints.down("sm")]: {
        paddingRight: 0,
        paddingLeft: 0,
        marginBottom: 24
      }
    },
    [theme.breakpoints.down("sm")]: {
      paddingRight: 0,
      paddingLeft: 0
    }
  },
  horseBar: {
    flex: "auto",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: theme.palette.common.white,
    borderRadius: 0
  },
  horseBarTitle: {
    fontSize: 20,
    fontWeight: "bold",
    [theme.breakpoints.down("xs")]: {
      fontSize: 18
    }
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    color: theme.palette.text.primary
  },
  closeIcon: {
    fontSize: 32
  },
  changesSavedWrapper: {
    position: "absolute",
    left: 24,
    [theme.breakpoints.down("xs")]: {
      left: 16
    }
  },
  changesSavedText: {
    display: "flex",
    justifyContent: "flex-end",
    fontSize: 13,
    color: theme.palette.text.hint,
    lineHeight: "normal",
    whiteSpace: "nowrap"
  },
  changesSavedIcon: {
    fontSize: 16
  },
  detailsLink: {
    cursor: "pointer"
  }
}));
